module.exports = __webpack_public_path__ + "img/delete-red.7a0dcf31.svg";